import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d081f2d")

_pushScopeId("data-v-7d081f2d")
const _hoisted_1 = { class: "talent-container" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "office-info" }, [
  /*#__PURE__*/_createVNode("h3", { class: "txt office-headline" }, "Barbie×Barbie🧸がonlyliveに登場"),
  /*#__PURE__*/_createVNode("p", { class: "txt office-info-text" }, [
    /*#__PURE__*/_createTextVNode("ショーウィンドウから逃げ出した５匹の人形たち。Barbie×Barbie！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("Barbie×Barbieとあなただけの、２人きりのオンライン通話ができるようになりました！"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("あなただけの特別な時間をお届けいたします！")
  ])
], -1)
const _hoisted_3 = { class: "contents-talent" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "txt office-headline" }, "タレント一覧", -1)
const _hoisted_5 = { class: "talent-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_talentListCard = _resolveComponent("talentListCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.talentLists, (talentList, index) => {
          return (_openBlock(), _createBlock(_component_talentListCard, {
            class: "element-talent-list-card",
            key: index,
            imageSrc: talentList.imageSrc,
            message: talentList.message,
            url: talentList.url
          }, null, 8, ["imageSrc", "message", "url"]))
        }), 128))
      ])
    ])
  ]))
})